import { useCallback, useReducer } from 'react';
import { OPERATIONS } from '../utils/constans';

const ACTIONS = {
    UPDATE: 'UPDATE',
};

const reducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.UPDATE:
            return {
                id: action.payload.id !== undefined ? action.payload.id : state.id,
                operation: action.payload.operation !== undefined ? action.payload.operation : state.operation
            };
        default:
            throw new Error();
    }
};

export const useManage = () => {
    const [state, dispatch] = useReducer(reducer, {
        id: null,
        operation: OPERATIONS.READ,
    });

    return [
        state,
        useCallback(
            (operation, id) => {
                dispatch({ type: ACTIONS.UPDATE, payload: { operation, id } })
            },
            []
        )
    ]
};